import { render, staticRenderFns } from "./dial_pad.vue?vue&type=template&id=0da7a1e4&scoped=true&"
import script from "./dial_pad.vue?vue&type=script&lang=js&"
export * from "./dial_pad.vue?vue&type=script&lang=js&"
import style0 from "./dial_pad.vue?vue&type=style&index=0&id=0da7a1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7a1e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
